/**
 * Merge point events from the SSE stream into local state.
 *
 * This runs on the same connection as the chat messages, so it must never throw
 * on an unexpected payload — a backend shape change would otherwise take the
 * whole message stream down with it.
 */
export function mergePoints(existing, incoming, removedIds = []) {
  const base = Array.isArray(existing) ? existing : [];
  const list = Array.isArray(incoming) ? incoming : [];

  const next = [...base];

  for (const raw of list) {
    if (!raw || typeof raw !== 'object' || raw.id == null) continue;
    const point = {
      id: raw.id,
      text: typeof raw.text === 'string' ? raw.text : '',
      source: raw.source === 'user' ? 'user' : 'ai',
      stance: ['supports', 'opposes', 'neutral'].includes(raw.stance)
        ? raw.stance
        : 'neutral',
      order: typeof raw.order === 'number' ? raw.order : 0,
      isNew: true,
    };
    const index = next.findIndex((p) => p.id === point.id);
    if (index === -1) {
      next.push(point);
    } else {
      // Upsert rather than append — makes duplicate flushes idempotent.
      next[index] = { ...next[index], ...point };
    }
  }

  const removed = new Set(
    (Array.isArray(removedIds) ? removedIds : []).filter((id) => id != null)
  );
  const pruned = removed.size ? next.filter((p) => !removed.has(p.id)) : next;

  return pruned.sort((a, b) => (a.order - b.order) || (a.id - b.id));
}

export function clearNewFlags(points) {
  return (Array.isArray(points) ? points : []).map((p) =>
    p.isNew ? { ...p, isNew: false } : p
  );
}
